// src/routes/Router.tsx
import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/Login';
import Textbausteine from '../pages/Textbausteine';
import Passwort from '../pages/Passwort';
import ProtectedRoute from './ProtectedRoute';
import BackendProvider from '../context/BackendContext';
import BeListe from '../pages/BeListe';
import VeListe from '../pages/VeListe';
import VeFormular from '../pages/VeFormular';
import VeFormularPrint from '../pages/VeFormularPrint';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/bestandsregie',
    element: <ProtectedRoute><BeListe /></ProtectedRoute>,
  },
  {
    path: '/veliste',
    element: <ProtectedRoute><VeListe /></ProtectedRoute>,
  },
  {
    path: '/veformular',
    element: <ProtectedRoute><VeFormular /></ProtectedRoute>,
  },
  {
    path: '/textbausteine',
    element: <ProtectedRoute><Textbausteine /></ProtectedRoute>,
  },
  {
    path: '/passwort',
    element: (
      <ProtectedRoute>
        <Passwort />
      </ProtectedRoute>
    ),
  },
  {
    path: '/print',
    element: <ProtectedRoute><VeFormularPrint /></ProtectedRoute>,
  },
]);

export default router;
